import React from 'react';
import { LabelIcon } from './LabelIcons';
import './labels.css';

const LabelBadge = ({ label, onRemove, removable = false }) => {
  if (!label) return null;
  const color = label.color || '#1a73e8';

  return (
    <span className="label-badge" style={{ '--label-color': color }} title={label.name}>
      <LabelIcon name={label.icon || 'label'} size={12} color={color} />
      <span className="label-badge-name">{label.name}</span>
      {removable && (
        <button
          type="button"
          className="label-badge-remove"
          aria-label={`Remove ${label.name}`}
          onClick={(event) => {
            event.stopPropagation();
            onRemove?.(label);
          }}
        >
          ×
        </button>
      )}
    </span>
  );
};

export default LabelBadge;
